import { render, staticRenderFns } from "./PaginaListadoRespuestasMuniTest.vue?vue&type=template&id=fa9501a8"
import script from "./PaginaListadoRespuestasMuniTest.vue?vue&type=script&lang=js"
export * from "./PaginaListadoRespuestasMuniTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports